import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/remote-config';
import 'firebase/storage';

const FUNCTIONS_REGION = "europe-west2";

const firebaseConfig = {
  apiKey: "AIzaSyBxm1o3BSTPYP-uK0yYN2elrqKeoKQUnD8",
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  databaseURL: "https://chuzeat-c-dev.firebaseio.com",
  projectId: "chuzeat-c-dev",
  storageBucket: "chuzeat-c-dev.appspot.com",
  messagingSenderId: "973255347351",
  appId: "1:973255347351:web:ffea17dfa98ebffb2d2dd2",
  measurementId: "G-VMSN22M8TM",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Optional named exports for convenience
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const functions = firebase.app().functions(FUNCTIONS_REGION);
export const remoteConfig = firebase.remoteConfig();
export const storage = firebase.storage();

firestore.settings({
  ignoreUndefinedProperties: true,
  merge: true,
});

remoteConfig.settings = {
  minimumFetchIntervalMillis: 3600000,
  fetchTimeoutMillis: 60000,
};

export async function initRemoteConfig() {
  try {
    await remoteConfig.fetchAndActivate();
    console.log("Remote Config activated");
  } catch (error) {
    console.warn("Remote Config failed:", error);
  }
}

export default firebase;